import { h, Component } from 'preact';
import style from './style';
import I18n from '@i18n';

const autocomplete = {
  password: 'current-password',
  tel: 'tel',
  email: 'email',
  CVC: 'cc-csc',
};

export class Select extends Component {
  render(props) {
    return (
      <label
        class={`${style.inputLabel} ${style.label} ${
          style[props.size] || style.medium
        } ${props.error ? style.error : ''}`}
      >
        <span class={`${style.labelGuide} ${style.labelFilled}`}>
          {props.placeholder}
        </span>
        <select {...props} placeholder={null} class={style.input} />
        <span class={style.labelHelp}>{props.title}</span>
        <svg
          class={style.selectIcon}
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          viewBox="0 0 24 24"
        >
          <path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" />
        </svg>
      </label>
    );
  }
}

export class Input extends Component {
  componentDidMount() {
    const props = this.props;
    if (props.value && props.textarea) {
      const textarea = this.base.querySelector('textarea');
      textarea.setAttribute('style', `height:${textarea.scrollHeight}px`);
    }
  }
  render(props, state) {
    return (
      <label
        class={`${style.label} ${style[props.size] || style.medium} ${
          props.error ? style.error : ''
        } ${state.dirty ? style.dirty : ''} ${
          props.strict ? style.strict : ''
        }`.trim()}
      >
        <span
          class={`${style.labelGuide} ${
            props.value || state.focused ? style.labelFilled : style.labelEmpty
          }`}
        >
          {props.placeholder}
        </span>
        {props.textarea ? (
          <textarea
            {...props}
            placeholder={null}
            class={style.input}
            autocomplete={
              props.autocomplete ||
              autocomplete[props.type] ||
              autocomplete[props.placeholder]
            }
            onFocus={e =>
              this.setState({ focused: true }, () => {
                if (props.onFocus) {
                  props.onFocus(e);
                }
              })
            }
            onBlur={e =>
              this.setState({ focused: false, dirty: true }, () => {
                if (props.onBlur) {
                  props.onBlur(e);
                }
              })
            }
          >
            {props.value}
          </textarea>
        ) : (
          <input
            {...props}
            placeholder={null}
            class={style.input}
            autocomplete={
              props.autocomplete ||
              autocomplete[props.type] ||
              autocomplete[props.placeholder]
            }
            onFocus={e =>
              this.setState({ focused: true }, () => {
                if (props.onFocus) {
                  props.onFocus(e);
                }
              })
            }
            onBlur={e =>
              this.setState({ focused: false, dirty: true }, () => {
                if (props.onBlur) {
                  props.onBlur(e);
                }
              })
            }
          />
        )}
        {props.value || state.focused ? null : (
          <span class={style.labelHelp}>
            {props.title
              ? props.title
              : !props.value && props.required
              ? I18n.t('Required')
              : ''}
          </span>
        )}
        {props.icon ? (
          props.resetIcon ? (
            <button
              type="button"
              class={style.resetButton}
              name={I18n.t('Reset')}
              onMouseDown={() => {
                props.onInput({ target: { value: '' } });
              }}
            >
              <svg
                class={style.selectIcon}
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                viewBox="0 0 24 24"
              >
                {props.icon.children}
              </svg>
            </button>
          ) : (
            <svg
              class={style.selectIcon}
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              viewBox="0 0 24 24"
            >
              {props.icon.children}
            </svg>
          )
        ) : null}
      </label>
    );
  }
}
export default Input;



// WEBPACK FOOTER //
// ./components/input/index.js